import CMSLandingPage from "./CMSLandingPage";

export default CMSLandingPage;
